/*eslint-disable */
switch (process.env.REACT_APP_SECRET_API) {
    case 'dev':
    module.exports = require('./dev');
    break;
    case 'psnm':
    module.exports = require('./psnm');
    break;
    case 'sit':
    module.exports = require('./sit');
    break;
    case 'suatp':
    module.exports = require('./prime');
    break;
    case 'suats':
    module.exports = require('./secundus');
    break;
    case 'suat':
    module.exports = require('./suat');
    break;
    case 'prod_e':
    module.exports = require('./prod_e');
    break;
    case 'prod_se':
    module.exports = require('./prod_se');
    break;
    default: null;
}